// @flow

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DateTimeFilter from '../Shared/Buttons/DateTimeFilter'
import CustomFilter from '../Shared/Buttons/CustomFilter'
import FilterBy from '../Shared/Filters/FilterBy'
import ContentPost from '../Shared/Data/ContentPost'
import MediumInfoBlock from '../Shared/Data/MediumInfoBlock'
import { fetchAlertDetails } from '../Redux/Actions/Details'
import BackArrow from '../Shared/Icons/icon-backarrow-grey.svg'
import './ContentDetails.css'
import './Wrappers.css'
import { componentCreated, updateDateFilter, updateGroupFilter } from '../Redux/Actions/DateFilter'
import { Link } from 'react-router-dom'
import { useLocation, useNavigate } from 'react-router'
import { composeFilterString, getDateFilter, getGroupFilter, processDate, processGroup } from '../utils/analytics-utils'
import { addQuery } from '../utils/router-utils'

function AlertDetails () {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const id = useSelector(state => state.account.ID)
  const data = useSelector(state => state.details.alert)
  const dateFilterStore = useSelector(state => state.dateFilter)
  const name = 'AlertDetails'

  let dateFilterFromStore = getDateFilter(dateFilterStore, name)
  dateFilterFromStore = dateFilterFromStore ? dateFilterFromStore.dateFilter || 'Week' : 'Week'
  const [dateFilter, setDateFilter] = useState(dateFilterFromStore)

  const groupFilterFromStore = getGroupFilter(dateFilterStore, name) || ''
  const [groupFilter, setGroupFilter] = useState(groupFilterFromStore)
  const dateInterval = dateFilter ? dateFilter.dateInterval || null : null

  const searchQ = location.search.substring(1).split('&')
  searchQ.forEach((q) => {
    searchQ[q.split('=')[0]] = q.split('=')[1]
  })

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    let alertId = ''
    const searchQ = location.search.substring(1).split('&')
    searchQ.forEach((q) => {
      if (q.split('=')[0] === 'id') {
        alertId = q.split('=')[1]
      }
    })
    const date = processDate(dateFilter)
    const group = processGroup(groupFilter)
    dispatch(fetchAlertDetails(id, date.start.toISOString(), date.end.toISOString(), alertId, {
      group: group.groups,
      profile: group.profiles,
      appType: group.alt
    }))
  }, [])

  useEffect(() => {
    newQuery(location.search.substring(1).split('&'))
  }, [])

  const newQuery = (query) => {
    const qobj = {}
    let newDateFilter
    query.forEach((q) => {
      qobj[q.split('=')[0]] = q.split('=')[1]
    })
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }
    update(processDate(newDateFilter), processGroup(groupFilter), id)
  }

  const changeDateFilter = (newFilter, isCustom) => {
    if (isCustom) {
      dispatch(updateDateFilter(name, 'Custom', newFilter))
    } else {
      dispatch(updateDateFilter(name, newFilter))
    }
    const f = `${composeFilterString(groupFilter.profiles, groupFilter.groups)}_${groupFilter.alt || ''}`
    addQuery({ date: newFilter, filter: f }, location, navigate)
    setDateFilter(newFilter)
    if (newFilter !== 'Custom') {
      update(processDate(newFilter), processGroup(groupFilter))
    }
  }

  const changeGroupFilter = (newFilter) => {
    let newDateFilter
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }

    dispatch(updateGroupFilter(name, newFilter))
    const f = `${composeFilterString(newFilter.profiles, newFilter.groups)}_${newFilter.alt || ''}`
    addQuery({ date: newDateFilter, filter: f }, location, navigate)
    setGroupFilter(newFilter)
    update(processDate(newDateFilter), processGroup(newFilter))
  }

  const update = (date, group, newID) => {
    const ID = newID || id
    const searchQ = location.search.substring(1).split('&')
    searchQ.forEach((q) => {
      searchQ[q.split('=')[0]] = q.split('=')[1]
    })
    dispatch(fetchAlertDetails(ID, date.start.toISOString(), date.end.toISOString(), searchQ.id, { group: group.groups, profile: group.profiles, appType: group.alt }))
  }

  return (
    <div className='ContentDetails'>
      <div className='toolbar'>
        <Link to={{ pathname: '/notification', search: `?id=${searchQ.id}&type=ALERT` }}>
          <img src={BackArrow} className='interactive' alt='back' />
        </Link>
        <div style={{ marginBottom: '5px' }}>
          <h2>
            Alert Overview
          </h2>
        </div>
        <DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} />
        <div />
      </div>
      {(dateFilter !== 'Day' && dateFilter !== 'Week' && dateFilter !== 'Month') ? <CustomFilter filterBy={changeDateFilter} currentFilter={dateFilter} /> : ''}
      <div className='ContentInternal ContentContainer'>
        <div className='col1'>
          <ContentPost title={data.alert_message} date={data.created} />
        </div>
        <div className='colbig col2'>
          <div className='filterInGrid'>
            <FilterBy
              changeFilter={changeGroupFilter}
              showProfiles
              showGroups
              type='App'
              currentFilter={processGroup(groupFilter)}
            />
          </div>
          <div className='firstColGrid'>
            <div>
              <MediumInfoBlock title='TOTAL VIEWS' value={data.totalViews} />
            </div>
            <div>
              <MediumInfoBlock title='ACCESSED THROUGH NOTIFICATIONS' value={`${(data.totalViewsNotifications || 0)}`} />
            </div>
          </div>
          <div className='secondColGrid'>
            <div>
              <MediumInfoBlock title='UNIQUE VIEWS' value={data.uniqueViews} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AlertDetails
